import { OpenFeature, ClientProviderEvents } from '@openfeature/react-sdk';
import { captureException } from '@mentimeter/errors/sentry';
import { MentiError } from '@mentimeter/error-utils/error';

export function addOpenFeatureHandlers() {
  OpenFeature.addHandler(ClientProviderEvents.Error, (errorEvent) => {
    captureException(
      new MentiError(errorEvent?.message || 'Unknown error', {
        feature: 'experimentation-client',
      }),
    );
  });
}
